import { Link } from "react-router-dom";

interface CharacterItem {
  id: string;
  name: string;
  role: string;
  intro: string;
  avatar: string;
}

export default function CharacterSpotlight({ characters }: { characters: CharacterItem[] }) {
  return (
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
      {characters.map((char) => (
        <Link
          key={char.id}
          to={`/character/${char.id}`}
          className="group rounded-lg overflow-hidden bg-background-100 border border-background-200 hover:border-primary-300 transition-colors cursor-pointer"
        >
          <div className="relative w-full aspect-square overflow-hidden">
            <img
              src={char.avatar}
              alt={`${char.name} 角色头像`}
              title={`公公与儿媳 角色 ${char.name}`}
              className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
            />
            <span className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-secondary-900/70 text-white text-[11px] backdrop-blur-sm">
              {char.role}
            </span>
          </div>
          <div className="p-3 md:p-4">
            <h3 className="font-heading font-semibold text-foreground-950 text-base group-hover:text-primary-700 transition-colors">
              {char.name}
            </h3>
            <p className="text-xs md:text-sm text-foreground-600 mt-1.5 line-clamp-2 leading-relaxed">
              {char.intro}
            </p>
          </div>
        </Link>
      ))}
    </div>
  );
}